export default __webpack_public_path__ + "static/media/banner.18d1c592.jpg";